export default "__VITE_ASSET__19be6c19__"